export function qs(sel, root) {
  return (root || document).querySelector(sel);
}

export function qsa(sel, root) {
  return Array.prototype.slice.call((root || document).querySelectorAll(sel));
}

export function normalizeText(s) {
  return (s || "").toString().trim().toLowerCase();
}

export function getCarsDom() {
  const grid = qs("#carsGrid");
  if (!grid) return null;

  return {
    grid,
    emptyState: qs("#emptyState"),
    resultCount: qs("#resultCount"),
    clearBtn: qs("#clearFilters"),
    searchInput: qs("#searchInput"),
    cards: qsa(".car-card", grid),
    brandChecks: qsa(".brand-check"),
  };
}